module.exports = __webpack_public_path__ + "img/vue2-arriere_bleu.95479818.png";